import PropTypes from 'prop-types';
import DescriptionAccordion from '../../util/DescriptionAccordion';

function DevicePolicyDescription({ tenantKey }) {
  let extension = `?key=${tenantKey}`;
  if (tenantKey === null || Number.isNaN(tenantKey)) {
    extension = '';
  }
  const href = `https://dialin.plcm.vc/teams/ps.html${extension}`;
  const docsHref = 'http://rc-docs.plcm.vc/docs/teams/trusted-device-config';

  return (
    <DescriptionAccordion title="What are trusted and untrusted devices?">
      <p>
        The following configuration allows for granular control of how the
        RealConnect Service defines if a call from a standards-based video
        system into a Microsoft Teams meeting is considered as coming from a{' '}
        <i>Trusted</i> or <i>Untrusted</i> device.
      </p>
      <p>
        <i>Trusted</i> devices will be treated as authenticated participants by
        Microsoft Teams, and thus allowed to bypass the meeting lobby when
        applicable. <i>Untrusted</i> devices will be treated as anonymous
        participants and be placed into the lobby when enforced on the meeting.
      </p>
      <p>
        By default all calls into the RealConnect Service are treated as
        untrusted until the Lobby Bypass feature is first enabled in the
        Microsoft tenant, via PowerShell by setting the{' '}
        <i>AllowAppGuestJoinsAsAuthenticated</i> parameter to &apos;$true&apos;
        as explained in the{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          id="PowerShellUri"
          href={href}
        >
          PowerShell Instructions for RealConnect for Teams
        </a>
        . The configuration below can then be used to define ‘known’ or
        ‘unknown’ devices by source IP addresses and/or subnet ranges, and
        whether or not to treat them as trusted or untrusted.
      </p>
      <p>
        For more details on how to define trusted and untrusted devices within
        the RealConnect Service and how they are treated differently when
        joining Microsoft Teams meetings and Live Events, please refer to the
        official{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          id="PowerShellUri"
          href={docsHref}
        >
          RealConnect Service documentation
        </a>
        .
      </p>
    </DescriptionAccordion>
  );
}

DevicePolicyDescription.propTypes = {
  tenantKey: PropTypes.string,
};

export default DevicePolicyDescription;
